import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, createSlots as _createSlots, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "col-span-6" }
const _hoisted_2 = { class: "col-span-6" }
const _hoisted_3 = { class: "col-span-6" }
const _hoisted_4 = { class: "col-span-6" }
const _hoisted_5 = { class: "col-span-6" }
const _hoisted_6 = { class: "col-span-6" }
const _hoisted_7 = { class: "col-span-6" }
const _hoisted_8 = { class: "col-span-6" }
const _hoisted_9 = { class: "col-span-6" }
const _hoisted_10 = { class: "col-span-6" }
const _hoisted_11 = { class: "col-span-6" }
const _hoisted_12 = { class: "col-span-full" }
const _hoisted_13 = { class: "pl-5 list-disc" }
const _hoisted_14 = { class: "text-gray-500 text-sm mt-1.5" }
const _hoisted_15 = { class: "col-span-6" }
const _hoisted_16 = { class: "col-span-6" }
const _hoisted_17 = { class: "col-span-6" }
const _hoisted_18 = { class: "col-span-6" }
const _hoisted_19 = { class: "col-span-6" }
const _hoisted_20 = { class: "col-span-6" }
const _hoisted_21 = { class: "col-span-6" }
const _hoisted_22 = { class: "col-span-6" }
const _hoisted_23 = { class: "col-span-6" }
const _hoisted_24 = { class: "col-span-6" }
const _hoisted_25 = {
  key: 0,
  class: "col-span-full"
}
const _hoisted_26 = {
  key: 1,
  class: "col-span-full"
}
const _hoisted_27 = { class: "col-span-full" }
const _hoisted_28 = { class: "col-span-6" }
const _hoisted_29 = { class: "col-span-6" }
const _hoisted_30 = { class: "col-span-6" }
const _hoisted_31 = { class: "col-span-6" }
const _hoisted_32 = { class: "col-span-6" }
const _hoisted_33 = { class: "col-span-6" }

import FormSection from '@/components/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';

import ButtonComponent from '@/components/ButtonComponent.vue';
import DropzoneInput from '@/components/inputs/DropzoneInput.vue';

import { useRoute } from 'vue-router';
import { ref, onMounted, computed, watch } from 'vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import BookingService from '@/classes/BookingService';
import { useNetworkStore } from '@/store/network';
import { onIonViewWillEnter } from '@ionic/vue';
import { format } from 'date-fns'
import { formateTimeSlot } from "@/helpers/TimeFormatter"
import { viewID } from "@/helpers/PackageRiderHelper"
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';
import { formatter } from "@/helpers/NumberHelper";
import { 
    formattedPackage,
} from '@/interfaces/CorporateBookingInterface'


export default /*@__PURE__*/_defineComponent({
  __name: 'EditFormSection',
  emits: ["fetched-item"],
  setup(__props, { emit: __emit }) {

const route = useRoute();

// const props = defineProps({
//     isNetworkAvailable: {
//         type: Boolean,
//         default: true,
//     },
// });

const loader = ref(false)
const showError = ref(false)
const errorMsg = ref(null)
const errors      = ref([])
const showSuccess = ref(false)
const showConfirmation = ref(false)
const showConfirmationPackageUpdate = ref(false)

const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

const appointment = ref(null);
const medicalQuestionnaireFilled = computed(() => appointment.value.medical_questionnaire ? 'Yes' : 'No');

// ! DEPRECATED
const packageFee = computed(() => {
    if(appointment.value.package_details.length > 0){
        console.log('hello');
        
        return appointment.value.package_details[0].trans_line.reduce((a, b) => a + b.price, 0)
    }
    
    return 0;

});

const riders = computed(() => {
    let items = '';

    if(typeof appointment.value?.other_charges_details == 'string') {
        return appointment.value?.other_charges_details;
    }

    if(appointment.value?.other_charges_details?.length > 0) {
        appointment.value?.other_charges_details[0]?.trans_line.forEach(element => {
            items += element.items ? element.items.description + ', ' : '';
        });
    }
    return items;
});

const miscFee = computed(() => {
    if(appointment.value?.package_details?.length > 0){
        
        return appointment.value?.package_details[0]?.trans_line?.reduce((a, b) => a + b.price, 0)
    }
    
    return 0;

});

const payload = ref({
    patient_id: null,
    email_address: null,
    last_name: null,
    first_name: null,
    sex: null,
    birthdate: null,
});

const emit = __emit

const isEmailValid = () => {
    const reg = /[^\s@]+@[^\s@]+\.[^\s@]+/;
    
    return reg.test(payload.value.email_address) ? true : false;
}

const fetchIndividualBooking = async() => {
    loader.value = true

    await BookingService.fetchIndividualBooking(route.params.bookingId)
        .then((result: any) => {
            loader.value = false;
            // console.log(result.data.response);
            appointment.value = result.data.response;

            emit("fetched-item", appointment.value);

            // Fill up payloads
            payload.value.patient_id = appointment.value.patient.patient_id;
            payload.value.email_address = appointment.value.patient.email_address;
            payload.value.last_name = appointment.value.patient.last_name;
            payload.value.first_name = appointment.value.patient.first_name;
            payload.value.sex = appointment.value.patient.sex;
            payload.value.birthdate = appointment.value.patient.birthdate;
            console.log()
            timeslot.value = formateTimeSlot(appointment.value.booking_start_time, appointment.value.booking_end_time)
            
            if(result.data.result_status == 500) {
                showError.value = true;
                errorMsg.value  = "Something went wrong. Please try again later";
            }
        })
        .catch((error) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error;

            if(error.response?.status == 401) {
                window.location.replace('/login')
            }


            if(error.response.status == 403) {
                errorMsg.value = "You don't permission to view to page";
            }
        })
}

const updatePatientEmail = () => {
    if(!isEmailValid()) {
        showError.value = true;
        errorMsg.value = "Please input a valid email address";

        return false;
    }

    loader.value = true;


    BookingService.updatePatientEmail(payload.value)
        .then((result: any) => {
            loader.value = false;
            if(result.data.response.result_status == 200 && result.data.response.message == 'Success') {
                showSuccess.value = true;
            } else if(result.data.response.result_status == 500) {
                showError.value = true;
                errorMsg.value  = "Something went wrong. Please try again later";
            }
        })
        .catch((error: any) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error.response.data.message;

            if(error.response.status == 422) {
                errors.value = error.response.data.errors;
            }

            if(error.response.status == 401) {
                window.location.replace('/login');
            }

            if(error.response.status == 403) {
                errorMsg.value = "You don't permission to view to page";
            }
        })
}

const updatePackageAndRiders = () => {
    loader.value = true;

    BookingService.updatePackageAndRiders(payloadPackageUpdate.value)
        .then((result: any) => {
            loader.value = false;
            if(result.data.response.result_status == 200 && result.data.response.message == 'Success') {
                showSuccess.value = true;
            } else if(result.data.response.result_status == 500) {
                showError.value = true;
                errorMsg.value  = "Something went wrong. Please try again later";
            }
        })
        .catch((error: any) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error.response.data.message;

            if(error.response.status == 422) {
                errors.value = error.response.data.errors;
            }

            if(error.response.status == 401) {
                window.location.replace('/login');
            }


            if(error.response.status == 403) {
                errorMsg.value = "You don't permission to view to page";
            }
        })
}

const doctorNote = ref(null);
const doctorTestResult = ref(null);
const timeslot = ref<string>('');

const fetchNoteAndResult = () => {
    loader.value = true

    BookingService.fetchNoteAndResult(route.params.bookingId)
        .then((result: any) => {
            loader.value = false;
            doctorNote.value = result.data.response.doctors_note;

            if(result.data.response.lab_result_base_64) {
                setTimeout(() => {
                    convertBase64ToPdf(result.data.response.lab_result_base_64);
                }, 100)
            }
            
            if(result.data.result_status == 500) {
                showError.value = true;
                errorMsg.value  = "Something went wrong. Please try again later";
            }
        })
        .catch((error) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error;

            if(error.response.status == 401) {
                window.location.replace('/login')
            }

            if(error.response.status == 403) {
                errorMsg.value = "You don't permission to view to page";
            }
        })
}

const convertBase64ToPdf = (base64File) => {

    if(base64File) {
        const decodedString = atob(base64File);
        const uint8Array = Uint8Array.from([...decodedString].map(char => char.charCodeAt(0)));
        const blob = new Blob([uint8Array], { type: 'application/pdf' });
        doctorTestResult.value = URL.createObjectURL(blob);
    }
}


const packages = ref([]);
const unformattedPackages = ref([]);
const selectedPackage = ref(null);

const payloadPackageUpdate =  ref({
    booking_id: route.params.bookingId,
    package_id: null,
    package_line: [
        {
            item_id: 1,
            price: 1,
            qty: 1
        },
    ]
})

const fetchPackagesAndRiders = async() => {
    loader.value = true

    await BookingService.getPackagesAndRiders()
        .then((result: any) => {
            unformattedPackages.value = result.data.packageResponse;
            
            formatPackages();

            loader.value = false;
        })
        .catch((error) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error;

            if(error.response.status == 401) {
                window.location.replace('/login')
            }
        })
}

const formatPackages = () => {
    unformattedPackages.value.forEach(unformattedPackage => {
        const formattedPackage: formattedPackage = {
            id   : null,
            label: null,
            value: null,
            disabledDates: null,
        };

        formattedPackage.id    = unformattedPackage.id;
        formattedPackage.value = unformattedPackage.id;
        formattedPackage.label = unformattedPackage.name + ' - ' + formatter.format(unformattedPackage.price);
        formattedPackage.disabledDates = unformattedPackage.disabledDates;
        packages.value.push(formattedPackage);

        const packageId = unformattedPackages.value.find((x: any) => x.name == appointment.value?.package_name)?.id;
        payloadPackageUpdate.value.package_id = packageId;
        selectedPackage.value = packageId;
    });
}

const clearPackagePayload = () => {
    // payloadPackageUpdate.value.package_fee = null;
    payloadPackageUpdate.value.package_id = null;
}

const selectPackage = (packageId:number) => {
    clearPackagePayload();

    const filteredPackage = unformattedPackages.value.filter(unformattedPackage => packageId == unformattedPackage.id);
    payloadPackageUpdate.value.package_id = filteredPackage[0]?.id;
    // payloadPackageUpdate.value.package_fee = filteredPackage[0]?.price;
    // payloadPackageUpdate.value.package_name = filteredPackage[0]?.name;
}

watch(
    () => selectedPackage.value,
    (val) => {
        if(val){
            selectPackage(val);
        } else {
            payloadPackageUpdate.value.package_id = null;
            // payloadPackageUpdate.value.package_fee = 0;
            // payloadPackageUpdate.value.package_name = '';
        }
    },
    { immediate: true }
);

onMounted(async() => {
    loader.value = true;

    console.log('Mounted Hook - Network: ' + isNetworkAvailable.value);
    await fetchIndividualBooking();
    // TODO : IF NEEDED
    // fetchNoteAndResult();

    await fetchPackagesAndRiders()
})

onIonViewWillEnter(async() => {
    loader.value = true;

    await fetchIndividualBooking();
    // TODO : IF NEEDED
    // fetchNoteAndResult();

    await fetchPackagesAndRiders();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (appointment.value)
      ? (_openBlock(), _createBlock(FormSection, { key: 0 }, _createSlots({
          title: _withCtx(() => [
            _cache[40] || (_cache[40] = _createTextVNode(" Booking Information ", -1))
          ]),
          description: _withCtx(() => [
            _cache[41] || (_cache[41] = _createTextVNode(" Relevant data and other details ", -1))
          ]),
          _: 2
        }, [
          (appointment.value)
            ? {
                name: "form",
                fn: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "First Name",
                      placeholder: "First Name",
                      modelValue: appointment.value.patient.first_name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((appointment.value.patient.first_name) = $event)),
                      id: "first_name",
                      name: "first_name"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "Middle Name",
                      placeholder: "Middle Name",
                      modelValue: appointment.value.patient.middle_name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((appointment.value.patient.middle_name) = $event)),
                      id: "middle_name",
                      name: "middle_name"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "Last Name",
                      placeholder: "Last Name",
                      modelValue: appointment.value.patient.last_name,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((appointment.value.patient.last_name) = $event)),
                      id: "last_name",
                      name: "last_name"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "Patient ID",
                      placeholder: "Patient ID",
                      modelValue: appointment.value.patient.patient_id,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((appointment.value.patient.patient_id) = $event)),
                      id: "patient_id",
                      name: "patient_id"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "Hospital ID",
                      placeholder: "Hospital ID",
                      modelValue: appointment.value.patient.hospital_no,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((appointment.value.patient.hospital_no) = $event)),
                      id: "hospital_no",
                      name: "hospital_no"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(TextInput, {
                      label: "Email Address",
                      placeholder: "Email Address",
                      modelValue: payload.value.email_address,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((payload.value.email_address) = $event)),
                      disabled: !isNetworkAvailable.value,
                      id: "email_address",
                      name: "email_address"
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "Branch",
                      placeholder: "Branch",
                      modelValue: appointment.value.branch_name,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((appointment.value.branch_name) = $event)),
                      id: "branch_name",
                      name: "branch_name"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "Medical Questionnaire Filled",
                      placeholder: "Medical Questionnaire Filled",
                      modelValue: medicalQuestionnaireFilled.value,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((medicalQuestionnaireFilled).value = $event)),
                      id: "medicalQuestionnaireFilled",
                      name: "medicalQuestionnaireFilled"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "Booking Date",
                      placeholder: "Booking Date",
                      modelValue: new Date(appointment.value.booking_date).toISOString().split('T')[0],
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((new Date(appointment.value.booking_date).toISOString().split('T')[0]) = $event)),
                      id: "booking_date",
                      name: "booking_date"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "Time Slot",
                      placeholder: "Time Slot",
                      modelValue: timeslot.value,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((timeslot).value = $event)),
                      id: "booking_start_time",
                      name: "booking_start_time"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(MultiselectInput, {
                      modelValue: selectedPackage.value,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedPackage).value = $event)),
                      id: "selectedPackage",
                      name: "selectedPackage",
                      label: "Package",
                      placeholder: "Package",
                      options: packages.value
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[42] || (_cache[42] = _createElementVNode("p", { class: "block text-sm text-gray-900" }, "Rider/s", -1)),
                    _createElementVNode("ul", _hoisted_13, [
                      _createElementVNode("li", _hoisted_14, _toDisplayString(riders.value), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(TextInput, {
                      disabled: "",
                      "add-on-left": "",
                      "add-on-text": "₱",
                      label: "Package Fee",
                      placeholder: "Package Fee",
                      id: "packageFee",
                      name: "packageFee",
                      modelValue: appointment.value.package_fee,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((appointment.value.package_fee) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(TextInput, {
                      disabled: "",
                      "add-on-left": "",
                      "add-on-text": "₱",
                      label: "Miscellaneous Fee",
                      placeholder: "Miscellaneous Fee",
                      modelValue: appointment.value.misc_fee,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((appointment.value.misc_fee) = $event)),
                      id: "miscFee",
                      name: "miscFee"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(TextInput, {
                      disabled: "",
                      "add-on-left": "",
                      "add-on-text": "₱",
                      label: "Discount Amount",
                      placeholder: "Discount Amount",
                      modelValue: appointment.value.discount_amount,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((appointment.value.discount_amount) = $event)),
                      id: "discount_amount",
                      name: "discount_amount"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(TextInput, {
                      disabled: "",
                      "add-on-left": "",
                      "add-on-text": "₱",
                      label: "Total Fee",
                      placeholder: "Total Fee",
                      modelValue: appointment.value.total_fee,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((appointment.value.total_fee) = $event)),
                      id: "total_fee",
                      name: "total_fee"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "Booking Type",
                      placeholder: "Booking Type",
                      modelValue: appointment.value.booking_type,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((appointment.value.booking_type) = $event)),
                      id: "booking_type",
                      name: "booking_type"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "Patient Type",
                      placeholder: "Patient Type",
                      modelValue: appointment.value.patient_type,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((appointment.value.patient_type) = $event)),
                      id: "patient_type",
                      name: "patient_type"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "Booking Status",
                      placeholder: "Booking Status",
                      modelValue: appointment.value.status,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((appointment.value.status) = $event)),
                      id: "status",
                      name: "status"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "HMO ID",
                      modelValue: appointment.value.patient.hmo_name,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((appointment.value.patient.hmo_name) = $event)),
                      placeholder: appointment.value.patient?.hmo_name ? 'Yes' : 'No',
                      id: "hmo_id",
                      name: "hmo_id"
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "Senior Citizen ID Uploaded",
                      placeholder: appointment.value.patient?.senior_citizen ? 'Yes' : 'No',
                      id: "senior_citizen",
                      name: "senior_citizen",
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_unref(viewID)(appointment.value.patient.senior_citizen_id_base_64)))
                    }, null, 8, ["placeholder"])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "PWD ID Uploaded",
                      placeholder: appointment.value.patient?.pwd_id_base_64 ? 'Yes' : 'No',
                      id: "pwd_id",
                      name: "pwd_id",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_unref(viewID)(appointment.value.patient.pwd_id_base_64)))
                    }, null, 8, ["placeholder"])
                  ]),
                  (doctorNote.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createVNode(TextInput, {
                          textarea: "",
                          disabled: "",
                          label: "Doctor's Note",
                          placeholder: "Doctor's Note",
                          modelValue: doctorNote.value,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((doctorNote).value = $event)),
                          id: "doctorNote",
                          name: "doctorNote"
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (doctorTestResult.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createVNode(DropzoneInput, {
                          label: "Test Result",
                          description: "PDF file",
                          modelValue: doctorTestResult.value,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((doctorTestResult).value = $event)),
                          id: "doctorTestResult",
                          name: "doctorTestResult"
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "Address Line",
                      placeholder: "Address Line",
                      modelValue: appointment.value.patient.building_number,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((appointment.value.patient.building_number) = $event)),
                      id: "addressLine",
                      name: "addressLine"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "Region",
                      placeholder: "Region",
                      modelValue: appointment.value.patient.region,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((appointment.value.patient.region) = $event)),
                      id: "region",
                      name: "region"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "Province",
                      placeholder: "Province",
                      modelValue: appointment.value.patient.province,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((appointment.value.patient.province) = $event)),
                      id: "province",
                      name: "province"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "City",
                      placeholder: "City",
                      modelValue: appointment.value.patient.city,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((appointment.value.patient.city) = $event)),
                      id: "city",
                      name: "city"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "Barangay",
                      placeholder: "Barangay",
                      modelValue: appointment.value.patient.barangay,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((appointment.value.patient.barangay) = $event)),
                      id: "barangay",
                      name: "barangay"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "Zip Code",
                      placeholder: "Zip Code",
                      modelValue: appointment.value.patient.zip_code,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((appointment.value.patient.zip_code) = $event)),
                      id: "zipCode",
                      name: "zipCode"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(TextInput, {
                      disabled: "",
                      label: "Mobile Number",
                      placeholder: "Mobile Number",
                      modelValue: appointment.value.patient.cellphone_number,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((appointment.value.patient.cellphone_number) = $event)),
                      id: "mobileNumber",
                      name: "mobileNumber"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                key: "0"
              }
            : undefined,
          (isNetworkAvailable.value)
            ? {
                name: "actions",
                fn: _withCtx(() => [
                  (_ctx.$hasPermission('set-individual-patient-appointment-time'))
                    ? (_openBlock(), _createBlock(ButtonComponent, {
                        key: 0,
                        onClick: _cache[30] || (_cache[30] = ($event: any) => (showConfirmation.value = true)),
                        class: "mr-2"
                      }, {
                        default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                          _createTextVNode(" Update Email ", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.$hasPermission('set-individual-patient-appointment-time'))
                    ? (_openBlock(), _createBlock(ButtonComponent, {
                        key: 1,
                        onClick: _cache[31] || (_cache[31] = ($event: any) => (showConfirmationPackageUpdate.value = true))
                      }, {
                        default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                          _createTextVNode(" Update Package ", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _renderSlot(_ctx.$slots, "default")
                ]),
                key: "1"
              }
            : undefined
        ]), 1024))
      : _createCommentVNode("", true),
    (loader.value)
      ? (_openBlock(), _createBlock(PageLoader, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(ErrorModal, {
      width: "w-[548px]",
      title: "Error",
      "action-text": "Close",
      "cancel-text": "Go back",
      show: showError.value,
      onClose: _cache[32] || (_cache[32] = ($event: any) => (showError.value = false)),
      onConfirm: _cache[33] || (_cache[33] = ($event: any) => (showError.value = false)),
      errors: errors.value
    }, {
      content: _withCtx(() => [
        _createTextVNode(_toDisplayString(errorMsg.value), 1)
      ]),
      _: 1
    }, 8, ["show", "errors"]),
    _createVNode(SuccessModal, {
      show: showSuccess.value,
      onCancel: _cache[34] || (_cache[34] = ($event: any) => (showSuccess.value = false)),
      onConfirm: _cache[35] || (_cache[35] = ($event: any) => (showSuccess.value = false)),
      "action-text": "Confirm",
      title: "Booking Submitted!",
      content: "Booking has been updated successfully"
    }, null, 8, ["show"]),
    _createVNode(ConfirmationModal, {
      show: showConfirmation.value,
      onCancel: _cache[36] || (_cache[36] = ($event: any) => (showConfirmation.value = false)),
      onConfirm: _cache[37] || (_cache[37] = ($event: any) => {showConfirmation.value = false; updatePatientEmail() }),
      "cancel-text": "Cancel",
      "action-text": "Confirm",
      title: "Update Booking?",
      content: "Are you sure you wish to update this booking?"
    }, null, 8, ["show"]),
    _createVNode(ConfirmationModal, {
      show: showConfirmationPackageUpdate.value,
      onCancel: _cache[38] || (_cache[38] = ($event: any) => (showConfirmationPackageUpdate.value = false)),
      onConfirm: _cache[39] || (_cache[39] = ($event: any) => {showConfirmationPackageUpdate.value = false; updatePackageAndRiders() }),
      "cancel-text": "Cancel",
      "action-text": "Confirm",
      title: "Update Booking?",
      content: "Are you sure you wish to update this booking?"
    }, null, 8, ["show"])
  ], 64))
}
}

})